import { Injectable } from "@angular/core";
import { OktaAuthService } from "@okta/okta-angular";
import jwt_decode from 'jwt-decode';

import { User } from "@core/models/user";
import { Roles } from "@core/globals/roles";

@Injectable({
	providedIn: 'root'
})
export class UserService {

	private user: User;

	constructor(public oktaAuthService: OktaAuthService) {
	}

	public async initializeUser(): Promise<User> {

		return new Promise<any>(async (resolve, reject) => {

			this.user = new User();

			this.oktaAuthService.getAccessToken().then(
				accessToken => {

					const decoded: any = jwt_decode(accessToken);
					const roles = decoded.roles as string[];

					this.user.roles = roles;
					this.user.hasFullAccess = roles.includes(Roles.Administrators) || roles.includes(Roles.FrontOffice);
					this.user.hasLoketAccess = roles.includes(Roles.Loket);
					this.user.hasWorkshopAccess = roles.includes(Roles.Workshop);

					resolve(this.user);
				}
			).catch((error) => reject(error));
		});
	}

	public getUser(): User {

		return this.user;
	}

	public resetUser(): void {

		this.user = null;
	}
}